import { getRouteApi } from '@tanstack/react-router';

const receiptsIndexRouteApi = getRouteApi('/_authed/receipts/');

export function useReceiptsRouteSearch() {
  return receiptsIndexRouteApi.useSearch();
}
